import { Injectable } from "@angular/core";
//import "rxjs/add/operator/toPromise";
import { Observable } from "rxjs";
import { IdValueItem } from "../models/id-value-item.model";

import { AppSettings } from "../settings/app.settings";
import { HttpClientService } from "../utilities/http.client";
import { IDictionary } from "./../interfaces/dictionary.interface";

@Injectable()
export class MiscService {
  constructor(
    private appSettings: AppSettings,
    private httpClient: HttpClientService
  ) { }

  private urls: IDictionary<any> = {
    "getRedirectorHashForUrl": this.appSettings.AdminApiPath + "RedirectorHash",
    "getNumberOfSifStartToleranceDays": this.appSettings.AdminApiPath + "GetNumberOfSifStartToleranceDays",
    "getDisableSupplierApiFlowReasons": this.appSettings.CommonApiPath + "disable-supplier-api-flow-reasons",
    "getBlendChangeReasons": this.appSettings.CommonApiPath + "blend-update-reasons",
    "getAddSupplierReminderMessage": this.appSettings.AdminApiPath + "GetAddSupplierReminderMessage",
    "getOtherFeesReasons": this.appSettings.CommonApiPath + "GetOtherFeesReasons",
    "getMaxCpiReasons": this.appSettings.CommonApiPath + "GetMaxCpiReasons",
    "getMaxCpiReasonsFeatureFlag": `${this.appSettings.AdminApiPath}GetSystemSettingsValue/{key}`,
    "getBlendAssistantReasonsForUpdate": this.appSettings.CommonApiPath + "blend-assistant-reasons",
  };

  getRedirectorHashForUrl(url: string): Promise<string> {
    return this.httpClient.post(this.urls["getRedirectorHashForUrl"], {}, JSON.stringify(url));
  }

  getNumberOfSifStartToleranceDays = (): Observable<number> =>
    this.httpClient.getSubscription(this.urls["getNumberOfSifStartToleranceDays"], {});

  getDisableSupplierApiFlowReasons(): Observable<string[]> {
    return this.httpClient.getSubscription(this.urls["getDisableSupplierApiFlowReasons"], {});
  }

  getBlendChangeReasons(): Observable<IdValueItem[]> {
    return this.httpClient.getSubscription(this.urls["getBlendChangeReasons"], {});
  }

  getAddSupplierReminderMessage(): Observable<string> {
    return this.httpClient.getSubscription(this.urls["getAddSupplierReminderMessage"], {});
  }

  getOtherFeesReasons(): Observable<IdValueItem[]> {
    return this.httpClient.getSubscription(this.urls["getOtherFeesReasons"], {});
  }

  getMaxCpiReasons(): Observable<IdValueItem[]> {
    return this.httpClient.getSubscription(this.urls["getMaxCpiReasons"], {});
  }

  getMaxCpiReasonsFeatureFlag(key: string): Observable<string> {
    return this.httpClient.getSubscription(this.urls["getMaxCpiReasonsFeatureFlag"], {key});
  }

  getBlendAssistantReasonsForUpdate(): Observable<IdValueItem[]> {
    return this.httpClient.getSubscription(this.urls["getBlendAssistantReasonsForUpdate"], {});
  }
}
